// Traduzioni EN della pagina Hosting & Domini (src/v2/pages/hosting.js).
// Pattern gettext: la STRINGA ITALIANA è la chiave; qui il valore inglese.
// Segnaposto {x} identici alla sorgente. Nessuna chiave duplicata.

const m = {
  // ── Comune / shell ──
  'Home': 'Home',
  'Caricamento…': 'Loading…',
  'Scopri le nostre offerte': 'Discover our offers',

  // ── Dashboard Hosting e Domini ──
  'Hosting e Domini': 'Hosting & Domains',
  'Dashboard Hosting e Domini': 'Hosting & Domains dashboard',
  'Sito web': 'Website',
  'Siti web': 'Websites',
  'Certificato SSL': 'SSL certificate',
  'Domini': 'Domains',
  'Nome': 'Name',
  'Applicazioni': 'Applications',
  'Ambienti': 'Environments',
  'Prodotto correlato': 'Related product',
  'Tag': 'Tag',
  'Free': 'Free',

  // ── Tab Sito web (vuoto) ──
  'Non hai nessun sito web': 'You have no website',
  'Crea un sito con il nostro Site Creator o installa WordPress in pochi clic.': 'Create a site with our Site Creator or install WordPress in a few clicks.',
  'Aggiungere un sito': 'Add a site',

  // ── Tab Hosting ──
  'Non hai nessun hosting': 'You have no hosting',
  'Ospita il tuo sito web con un piano hosting NeoFlux ad alte prestazioni.': 'Host your website with a high-performance NeoFlux hosting plan.',
  'Ordina un hosting': 'Order a hosting',
  'Ordinare': 'Order',
  'Gestire': 'Manage',
  'Prodotti correlati': 'Related products',
  'Scadenza': 'Expiry',
  'Scade il {data}': 'Expires on {data}',

  // ── Tab Domini ──
  'Non hai nessun dominio': 'You have no domain',
  'Inizia ordinando o trasferendo il dominio perfetto per il tuo progetto.': 'Start by ordering or transferring the perfect domain for your project.',
  'Ordina o trasferisci un dominio': 'Order or transfer a domain',
  'Dominio': 'Domain',
  'Ordina': 'Order',
  'Gestisci': 'Manage',
  'Titolare': 'Owner',
  'Prodotti collegati': 'Linked products',
  'Opzioni': 'Options',
  'Protezione privacy attiva': 'Privacy protection active',
  'Aggiungi un tag': 'Add a tag',
  'Elaborazione in blocco': 'Bulk processing',
  'dominio selezionato': 'domain selected',
  'domini selezionati': 'domains selected',
  'Ottieni codici di trasferimento': 'Get transfer codes',
  'Trasferisci a NeoFlux': 'Transfer to NeoFlux',
  'Cambia titolare': 'Change owner',
  'Applico…': 'Applying…',
  'Modifica server DNS': 'Edit DNS servers',
  'Blocco…': 'Locking…',
  'Blocca': 'Lock',
  'Modifica i server DNS': 'Edit the DNS servers',
  'dominio': 'domain',
  'domini': 'domains',
  'I nuovi server DNS verranno applicati a tutti i domini selezionati.': 'The new DNS servers will be applied to all selected domains.',
  'Server DNS {n}': 'DNS server {n}',
  'Annulla': 'Cancel',
  'Applica': 'Apply',

  // ── Tab Certificato SSL (vuoto) ──
  'Aggiungi certificato': 'Add certificate',
  'Proteggi e autentica i tuoi siti e domini aggiungendo il tuo primo certificato SSL.': 'Protect and authenticate your sites and domains by adding your first SSL certificate.',

  // ── Azioni in blocco (messaggi) ──
  '{label}: {ok}/{tot} riusciti.': '{label}: {ok}/{tot} succeeded.',
  'Blocco domini': 'Domain locking',
  'Inserisci almeno i primi due server DNS': 'Enter at least the first two DNS servers',

  // ── Dettaglio dominio ──
  'Dominio non trovato.': 'Domain not found.',
  'Operazione non riuscita sul registrar': 'Operation failed on the registrar',
  'Impossibile aggiornare il rinnovo automatico': 'Unable to update automatic renewal',
  'Privacy WHOIS {stato}.': 'WHOIS privacy {stato}.',
  'attivata': 'enabled',
  'disattivata': 'disabled',
  'DNSSEC {stato}.': 'DNSSEC {stato}.',
  'attivato': 'enabled',
  'disattivato': 'disabled',
  'Dominio {stato}.': 'Domain {stato}.',
  'bloccato': 'locked',
  'sbloccato': 'unlocked',
  'Non disponibile': 'Not available',
  'Richiesta di rinnovo inviata al registrar.': 'Renewal request sent to the registrar.',
  'Server DNS aggiornati.': 'DNS servers updated.',

  // ── Titoli sezione (dettaglio dominio) ──
  'Pannello di controllo': 'Control panel',
  'Server DNS': 'DNS servers',
  'Zona DNS': 'DNS zone',
  'Dettagli Whois': 'Whois details',
  'Trasferimento': 'Transfer',
  'Reindirizzamenti web': 'Web redirects',
  'Domini sinonimo': 'Synonym domains',
  'DNS dinamico': 'Dynamic DNS',
  'Collega un servizio': 'Link a service',

  // ── Toggle / stato ──
  'Attivo': 'Active',
  'Disattivato': 'Disabled',
  'In attesa': 'Pending',

  // ── Intestazione dettaglio dominio ──
  'Aggiungere un tag': 'Add a tag',
  'Titolare: {owner} · Scade il {data}': 'Owner: {owner} · Expires on {data}',
  'Rinnovo…': 'Renewing…',
  'Rinnova il dominio': 'Renew the domain',
  'Trasferisci il dominio': 'Transfer the domain',

  // ── Pannello di controllo ──
  'Servizi collegati': 'Linked services',
  'Dominio / sottodominio': 'Domain / subdomain',
  'Email': 'Email',
  'Web e Cloud': 'Web & Cloud',
  'Altro': 'Other',
  'dominio primario': 'primary domain',
  'Rinnovo automatico': 'Automatic renewal',
  'Rinnova automaticamente il dominio prima della scadenza.': 'Automatically renew the domain before it expires.',
  'Privacy WHOIS': 'WHOIS privacy',
  'Nasconde i tuoi dati personali nella banca dati WHOIS pubblica.': 'Hides your personal data from the public WHOIS database.',
  'Blocco del trasferimento': 'Transfer lock',
  'Impedisce il trasferimento non autorizzato verso un altro registrar.': 'Prevents unauthorized transfer to another registrar.',
  'Bloccato': 'Locked',
  'Sbloccato': 'Unlocked',
  'Protegge la risoluzione DNS del dominio con firme crittografiche.': "Protects the domain's DNS resolution with cryptographic signatures.",
  'Azioni': 'Actions',
  'Cambia la zona DNS': 'Change the DNS zone',
  'Aggiungi un dominio sinonimo': 'Add a synonym domain',
  'Aggiungi un reindirizzamento web': 'Add a web redirect',
  'Informazioni sul dominio': 'Domain information',
  'Stato': 'Status',
  'Data di registrazione': 'Registration date',
  'Data di scadenza': 'Expiry date',
  'Rinnova adesso': 'Renew now',
  'Servizio collegato': 'Linked service',
  'Nessuno': 'None',

  // ── Server DNS ──
  'Server DNS (name server)': 'DNS servers (name servers)',
  'Questa sezione è riservata agli utenti esperti. Una gestione errata può causare malfunzionamenti del dominio e dei servizi collegati. Le modifiche sono applicate direttamente, ma la propagazione su Internet può richiedere diverse ore.': 'This section is reserved for expert users. Incorrect management can cause malfunctions of the domain and linked services. Changes are applied immediately, but propagation across the Internet can take several hours.',
  'Server DNS NeoFlux': 'NeoFlux DNS servers',
  'Server DNS personalizzati': 'Custom DNS servers',
  'Server primario *': 'Primary server *',
  'Server secondario *': 'Secondary server *',
  'es. ns1.provider.com': 'e.g. ns1.provider.com',
  'Salvataggio…': 'Saving…',
  'Conferma': 'Confirm',
  'Server primario': 'Primary server',
  'Server secondario': 'Secondary server',
  'Server {n}': 'Server {n}',
  'Nessun server DNS configurato.': 'No DNS server configured.',

  // ── Zona DNS ──
  'Gestisci la zona DNS del dominio': 'Manage the domain DNS zone',
  'I record DNS servono per varie funzioni: indirizzare un dominio verso un sito web, configurare le email, verificarne l’autenticità e altro ancora.': 'DNS records serve various purposes: pointing a domain to a website, configuring email, verifying its authenticity and more.',
  'Questa sezione è riservata agli utenti esperti.': 'This section is reserved for expert users.',
  'Una gestione errata può causare malfunzionamenti del dominio e dei servizi collegati.': 'Incorrect management can cause malfunctions of the domain and linked services.',
  'La zona DNS di questo dominio è gestita dai server DNS NeoFlux. La gestione dei singoli record (A, AAAA, MX, TXT, CNAME) sarà disponibile a breve da questa sezione.': "This domain's DNS zone is managed by the NeoFlux DNS servers. Management of individual records (A, AAAA, MX, TXT, CNAME) will be available soon from this section.",
  'La zona DNS non è gestita da NeoFlux perché il dominio usa server DNS esterni:': 'The DNS zone is not managed by NeoFlux because the domain uses external DNS servers:',
  'Usa i server DNS NeoFlux': 'Use the NeoFlux DNS servers',

  // ── Dettagli Whois ──
  'Titolare del dominio': 'Domain owner',
  'I dati di contatto sono protetti dalla privacy WHOIS.': 'The contact data is protected by WHOIS privacy.',
  'Dati di contatto non disponibili. Sincronizza il dominio o contatta l’assistenza.': 'Contact data not available. Sync the domain or contact support.',
  'Modifica': 'Edit',
  'La modifica del titolare (trasferimento di proprietà) e dei contatti WHOIS va richiesta all’assistenza NeoFlux.': 'Changing the owner (transfer of ownership) and the WHOIS contacts must be requested from NeoFlux support.',

  // ── Trasferimento ──
  'Trasferimento del dominio': 'Domain transfer',
  'Blocco registrar': 'Registrar lock',
  'Codice di autorizzazione (EPP)': 'Authorization code (EPP)',
  'Nascondi': 'Hide',
  'Mostra': 'Show',
  'Per trasferire questo dominio verso un altro registrar, sbloccalo e fornisci il codice di autorizzazione. Per un trasferimento in entrata verso NeoFlux, contatta l’assistenza.': 'To transfer this domain to another registrar, unlock it and provide the authorization code. For an inbound transfer to NeoFlux, contact support.',

  // ── Sezioni non supportate ──
  'Questa funzione non è ancora disponibile per i domini registrati con NeoFlux.': 'This feature is not yet available for domains registered with NeoFlux.',
  'Sarà attivata prossimamente da questa sezione.': 'It will be enabled soon from this section.',

  // ── Dettaglio hosting ──
  'illimitato': 'unlimited',
  '{used} / {limit} utilizzati': '{used} / {limit} used',
  'Aggiungere un utente': 'Add a user',
  'Aggiungi un database': 'Add a database',
  'Restauro': 'Restore',
  'Nessun salvataggio': 'No backup',
  'Sicurezza': 'Security',
  'Nessun sito da analizzare': 'No site to scan',
  'Azioni rapide': 'Quick actions',
  'Accedere al WebFTP': 'Access WebFTP',
  'Accedere a PhpMyAdmin': 'Access PhpMyAdmin',
  'Ripristinare il mio hosting': 'Restore my hosting',
  'Attivare la manutenzione': 'Enable maintenance',
  'La mia offerta': 'My offer',
  'Siti': 'Sites',
  'Archiviazione': 'Storage',
  'Rinnovo': 'Renewal',
  'Il {data}': 'On {data}',
  'Risorse': 'Resources',
  'Condivise': 'Shared',
  'Creare un primo sito web': 'Create a first website',
  "Aggiungi un sito e scegli la configurazione o l'applicazione più adatta a te.": 'Add a site and choose the configuration or application that best suits you.',
  'Sito': 'Site',
  'Nuovo': 'New',
  'Sfrutta le ultime tecnologie per i tuoi siti web in tutta facilità.': 'Leverage the latest technologies for your websites with ease.',
  'Crea un sito con Node.js': 'Create a site with Node.js',
  'Maggiori informazioni': 'More information',
  "Nome dell'host": 'Hostname',
  'Condiviso': 'Shared',
  'Percorso assoluto': 'Absolute path',
  'IP dedicati': 'Dedicated IPs',
};

export default m;
